import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { isNullOrUndefined } from 'util';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';

@Component({
  selector: 'app-order-details-general-info',
  templateUrl: './order-details-general-info.component.html',
  styleUrls: ['./order-details-general-info.component.css']
})
export class OrderDetailsGeneralInfoComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];
  showCharacteristics: boolean;
  orderId: string;

  @Output() decompositeOrderEvent = new EventEmitter();

  constructor() {

  }

  ngOnInit() { }

  public isCrmItem(): boolean {
    if (isNullOrUndefined(this.summary)) return false;
    return this.summary.type.name === OrderTypeObject.CRM.name;
  }

  decompositeOrder() {
    this.decompositeOrderEvent.emit();
  }

}
